
/**
 * Deep clone a multi dimensional array.
 *
 * @return {array}
 */
Array.prototype.clone = function() {

	let arr = this.slice( 0 );

	for ( let i = 0; i < this.length; i++ ) {
		if ( this[ i ].clone ) {
			// Recursion.
			arr[ i ] = this[ i ].clone();
		}
	}

	return arr;

};


/**
 * Create a unique array.
 *
 * @return {array}
 */
Array.prototype.unique = function() {

	return [ ...new Set( this ) ];

};
